import { chain, flatten, isEmpty, pick, values } from 'lodash';

export default class AddressFormError {
  address: string[] = []
  latitude: string[] = []
  longitude: string[] = []
  line1: string[] = []
  line2: string[] = []
  city: string[] = []
  county: string[] = []
  country: string[] = []
  postcode: string[] = []

  // The address fields, for pages that have no address inputs to render them against
  get address_errors(): string[] {
    return flatten(values(pick(this, [
      'address', 'latitude', 'longitude', 'line1', 'line2', 'city', 'county', 'country', 'postcode',
    ])))
  }

  get has_errors(): boolean {
    return (
      chain(this)
      .values()
      .filter(errors => !isEmpty(errors))
      .some()
      .value()
    )
  }
}